import { TmAddress, TmCreditCard, TmAccount } from './account';
import { TmGiftCard } from './giftcard';
import { TmProduct, TmEdp, TmProductCustomField } from './product';

export class TmCart {
    CartGuid: string;
    PaymentMethod: string;
    ShipCode: string;
    IsRogersCCOnFile: boolean;
    IsDonationFlowEnabled: boolean;
    PromoCode: string;
    IsMaxCartCheckoutLimitReached: boolean;
    IsMaxCartLineCountReached: boolean;
    IsMaxQuantityPerCartLineReached: boolean;
    IsPhysicalDeliveryAddressRequired: boolean;
    IsCartMerged: boolean;
    OrderSummary: TmCartOrderSummary;
    ShippingAddress: TmAddress;
    CreditCard: TmCreditCard;
    RelatedCartIds: number[];
    HasRemoteShipTo: boolean;
    GiftCards: TmGiftCard[];
    CartMessages: TmCartMessageType;
    AvailableShipMethods: TmShipMethod[];
    AvailableInstallments: string[];
    AvailableInstallmentsBreakdown: TmInstallmentBreakdown[];
    PromotionalEasyPayInstallment: TmInstallmentBreakdown;
    CartLines: TmCartLine[];
    Buyer: TmAccount;
    Products: TmProduct[];
    UpsellProducts: TmProduct[];
}

export class TmInstallmentBreakdown {
    NoOfInstallments: number;
    MonthlyPayment: string;
}

export class TmCartOrderSummary {
    OrderNo: string;
    TotalQuantity: number;
    MerchandiseSubTotal: string;
    MerchandiseSubTotalAmount: number;
    Discount: string;
    DiscountAmount: number;
    PromotionValue: string;
    PromotionDetails: string[];
    PromocodeNotAppliedMessage: string;
    DefaultShippingHandling: string;
    DefaultShippingHandlingAmount: number;
    ShippingHandling: string;
    ShippingHandlingAmount: number;
    TaxTotal: string;
    TaxTotalAmount: number;
    GiftCard: string;
    GiftCardAmount: number;
    AppliedCredit: string;
    AppliedCreditAmount: number;
    AvailableAccountCredit: string;
    AvailableAccountCreditAmount: number;
    GrandTotal: string;
    GrandTotalAmount: number;
    MultipackSavings: string;
    MultipackSavingsAmount: number;
    TotalSavings: string;
    EasyPay: TmEasyPay;
    ShipmentProvince: string;
    IsAutoFreeShipApplied: boolean;
    AutoFreeShipAwayFromThreshold: string;
    AutoFreeShipAwayFromThresholdAmount: number;
    IsRogersCCFreeShipApplied: boolean;
    PreviousOrderTotal: string;
    OrderTotalDifference: string;
    AppliedPromocode: string;
    PromocodeMessage: string;
    NewOrderNumbers: any[];
    TotalOrderAmount: string;
}

export class TmCartMessageType {
    OfferDiscountMessage: string;
    OfferShippingMessage: string;
    OfferQualifyOrNot: string;
    OfferApplied: string;
    MaxCheckoutLimitReached: string;
    MaxCartLineCountReached: string;
    MaxQuantityPerCartLineReached: string;
    PhysicalAddressRequired: string;
    GiftCardNotEligible: string;
    OutOfStockMessage: string;
    FreeShippingMessage: string;
    EstimatedDate: string;
    EstimatedDateLabel: string;
}
export class TmShipMethod {
    Method: string;
    Label: string;
    Description: string;
    ShippingCost: string;
    CourierType: string;
    EstimatedDeliveryDate: string;
}
export class TmCartLine {
    Id: number;
    InCart: TmInCart;
    CartLineItem: TmEdp;
}

//2nd level models
export class TmEasyPay {
    NoOfInstallments: 1;
    TotalPaymentToday: string;
    BalanceRemainingAfterToday: string;
    NoOfFutureMonthlyPayments: 0;
    FutureMonthlyPayment: string;
}

export class TmInCart {
    ItemNo: string;
    ShippingHandling: string;
    PricePromoLabel: string;
    ShowPricePromo: boolean;
    UnitPrice: string;
    PriceUnit: number;
    WasPrice: string;
    Discount: string;
    Quantity: number;
    IsFreeShippingEligible: boolean;
    TaxLabel: string;
    TotalPrice: string;
    ShippingMessage: string;
    IsEditable: boolean;
    IsPromoEligible: boolean;
    QuantityToBeReducedMessage: string;
    CustomFields: TmProductCustomField[];
    EstimatedDateLabel: string;
    EstimatedDeliveryDate: string;
    EstimatedShipDate: string;
    SODeliveryMessage: string;
    UpsellMessage: string;
}

export class TmCartNotice {
    ItemNo: string;
    EdpNo: number;
    CartId: number;
    ItemName: string;
    Message: string;
    StockStatus: string;
    Action: string;
}
